module.exports = __webpack_public_path__ + "components/affiliate-fillers/booking/static/filler-d8f2fd1c988b6b73016438dec4a4f628.jpg";